export const iconSize = 30
export const leftPadding = iconSize + 15
export const fontSize = 18
export const lineHeight = 22
export const inputHeight = 70
